<template>
  <div class="maintaining_page">
    <h1>Maintaining...</h1>
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>